import { TPropsWithChildren } from '@ftd/types'
import { Text as MantineText, type TextProps } from '@mantine/core'

export type TTypographyProps = TextProps

export const Typography: TPropsWithChildren<TTypographyProps> = ({ children, variant = 'text', ...props }) => (
  <MantineText variant={variant} {...props}>
    {children}
  </MantineText>
)
